import Observable from '../observable';
import GooglePrediction from './google/google_prediction';
import GooglePlaces from './google/google_places';
import { throttle } from '../../lib/utilities';

class Addressify extends Observable {
	constructor($input, $results, termProvider) {
		super();

		this.$input              = $input;
		this.$results            = $results;
		this.termProvider        = termProvider || this.termProvider;
		this.$activeResult       = {};
		this.places              = null;
		this.predictionParser    = new GooglePrediction();
	}

	init() {
		'use strict';

		this.initResults()
			.initPlaces()
			.bindHandler();
	}

	/**
	 * @return {Addressify}
	 */
	initPlaces() {
		'use strict';
		this.places = new GooglePlaces({ country: TYROOLA.globals.countryMainStore });
		return this;
	}

	/**
	 * @return {Addressify}
	 */
	initResults() {
		'use strict';
		if (!this.$results) {
			this.createResultsContainer();
		}

		this.$input.on('keyup', $.proxy(this.handleFocusOfResults, this));

		return this;
	}

	/**
	 * @param  {Event} e
	 * @return {Addressify}
	 */
	handleFocusOfResults(e) {
		'use strict';


		if (!this.isResultsOpen) {
			return;
		}

		if (e.which === 13) { //Enter
			e.preventDefault();
			e.stopPropagation();
			this.submitActiveResult();
		}

		if (e.which === 40) { //Keydown
			this.handleResultKeyPressDown();
		}

		if (e.which === 38) { //Keyup
			this.handleResultKeyPressUp();
		}

		if (e.which === 27) { //Hide results
			this.hideResults();
		}

		return this;
	}

	/**
	 * @param  {Obejct} $result [jQuery]
	 * @return {Addressify}
	 */
	activateResult($result) {
		'use strict';

		if (this.$activeResult && this.$activeResult.length) {
			this.$activeResult.removeClass('active');
		}

		this.$activeResult   = $result.addClass('active');
		this.activeIndex = this.$activeResult.index();
		return this;
	}

	/**
	 * @return {Addressify}
	 */
	deactivateResult() {
		'use strict';

		if (this.$activeResult && this.$activeResult.length) {
			this.$activeResult.removeClass('active');
			this.activeIndex = -1;
			this.$activeResult = {};
		}
		return this;
	}

	/**
	 * @return {Addressify}
	 */
	handleResultKeyPressDown() {
		'use strict';

		if (!this.$activeResult.length) {
			this.activateResult(this.$results.find('li').first());
			return this;
		}

		if (this.activeIndex >= this.lastIndex) {
			return this;
		}

		this.activateResult(this.$activeResult.next());

		return this;
	}

	/**
	 * @return {Addressify}
	 */
	handleResultKeyPressUp() {
		'use strict';

		if (!this.$activeResult.length) {
			return this;
		}

		if (this.activeIndex < this.firstIndex) {
			this.deactivateResult();
		}

		this.activateResult(this.$activeResult.prev());
		return this;
	}


	/**
	 * Dynamically generate results space
	 * @return {Addressify}
	 */
	createResultsContainer() {
		'use strict';
		var $results, $container;

		$results   = $('<ul class="addressify-results"/>');
		$container = $('<div class="addressify-result-container"/>');
		$results.wrap($container);

		this.$input.parent().css('position', 'relative').append($container.append($results));
		this.$results          = $results;
		this.$resultsContainer = $container;
		return this;
	}

	bindHandler() {
		'use strict';

		this.$input.on('keypress', $.proxy(this.throttledFetchAdresses(500), this));
	}

	/**
	 * @return {null}
	 */
	fetchAddresses() {
		'use strict';
		var currentTerm = this.termProvider();

		if (!currentTerm) {
			return;
		}

		if (currentTerm && currentTerm.length < 4) {
			return;
		}

		this.loading('add');

		this.places.predict(currentTerm, $.proxy(this.displayAutocomplete, this));
	}

	/**
	 * @param  {String} currentTerm
	 * @return {Object}
	 */
	getAutoCompleteData(currentTerm) {
		'use strict';

		return { term : currentTerm };
	}

	/**
	 * @param  {Number} throttleLength
	 * @return {Function}
	 */
	throttledFetchAdresses(throttleLength) {
		'use strict';
		return throttle($.proxy(this.fetchAddresses, this), throttleLength);
	}


	cleanAddresses() {
		'use strict';
		this.$resultsContainer.hide();
		this.$results.html('');
	}

	/**
	 * @param  {Array} addresses
	 * @return {Addressify}
	 */
	displayAutocomplete(addresses) {
		'use strict';
		var numAddresses;

		if (!addresses) {
			//Maybe display no results here?
			this.loading('remove');
			return this;
		}

		if (!addresses.length) {
			//Maybe display no results here?
			this.loading('remove');
			return this;
		}

		numAddresses = addresses.length;

		this.cleanAddresses();

		for (var i = 0; i < numAddresses; i++) {
			this.handlePrediction(addresses[i]);
		}

		this.firstIndex = 0;
		this.lastIndex = (numAddresses - 1);
		this.loading('remove');
		this.showResults();
		return this;
	}

	/**
	 * @param {Object} prediction
	 * @return {Addressify}
	 */
	handlePrediction(prediction) {
		'use strict';
		var $address;

		this.predictionParser.parse(prediction);
		$address = $(
			this.getAddressMarkup(
				this.predictionParser.getAddress(),
				this.predictionParser.getPlaceId()
			)
		);

		this.bindResultHandle(
			$address,
			this.predictionParser.getAddress(),
			this.predictionParser.getPlaceId()
		);

		this.$results.append($address);

		return this;
	}

	/**
	 * @return {Addressify}
	 */
	showResults() {
		'use strict';
		this.$resultsContainer.show();
		this.isResultsOpen = true;
		return this;
	}

	/**
	 * @return {Addressify}
	 */
	submitActiveResult() {
		'use strict';

		if (this.$activeResult && typeof this.$activeResult.html !== 'undefined') {
			this.notify(this.$activeResult.html(), this.$activeResult.data('id'));
		}
		this.hideResults();
		return this;
	}

	/**
	 * @param  {Object} $address [jQuery]
	 * @param  {String} address
	 * @return {Addressify}
	 */
	bindResultHandle($address, address, placeId) {
		'use strict';
		$address.on('click', this.handleAddressClick.bind(this, address, placeId));
		$address.hover(
			$.proxy(this.activateResult, this, $address),
			$.proxy(this.deactivateResult, this)
		);
	}

	/**
	 * @param  {String} address
	 * @return {String}
	 */
	getAddressMarkup(address, placeId) {
		'use strict';
		return '<li data-id="' + placeId + '">' + address + '</li>';
	}

	/**
	 * @param  {String} address
	 * @return {Addressify}
	 */
	handleAddressClick(address, placeId) {
		'use strict';
		this.notify(address, placeId);
		this.hideResults();
		return this;
	}

	/**
	 * @return {Addressify}
	 */
	hideResults() {
		'use strict';
		this.$resultsContainer.hide();
		this.isResultsOpen = false;
		return this;
	}

	/**
	 * @return {Boolean}
	 */
	isActive() {
		'use strict';
		return this.isResultsOpen;
	}

	/**
	 * @param  {String} addOrRemove
	 * @return {Addressify}
	 */
	loading(addOrRemove) {
		'use strict';
		this.$input[addOrRemove + 'Class']('loading-small');
		return this;
	}

	/**
	 * Default term provider
	 * @return {String}
	 */
	termProvider() {
		'use strict';
		return this.$input.val();
	}
}

export default Addressify;
